import { render, staticRenderFns } from "./affix.vue?vue&type=template&id=15ef650c&"
import script from "./affix.vue?vue&type=script&lang=js&"
export * from "./affix.vue?vue&type=script&lang=js&"
import style0 from "./affix.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports